import { ApiGetIspPortalsResponse } from './api-get-isp-portals.response';
import con from '../../../connection';

const path = '/portals';

const portals = (url: string) => () => ({
  get: () => con.get<ApiGetIspPortalsResponse>(url + path, {}),
});

export default portals;
